









































































import { Component, Vue } from "vue-property-decorator";
import { SoundString } from "@/types";
import { loadLanguageAsync } from "@/translations";
import ActionBtn from "@/components/ActionBtn.vue";

@Component({
  components: { ActionBtn }
})
export default class Home extends Vue {
  goToFrameScreen() {
    this.$router.push({
      name: "painting",
      params: { lang: this.$i18n.locale }
    });
  }

  selectLanguage(lang: "pt" | "en"): void {
    loadLanguageAsync(lang);
    this.$router.replace({ name: "root" });
  }

  created() {
    if (
      this.$route.params.lang &&
      this.$route.params.lang !== this.$i18n.locale
    ) {
      this.selectLanguage(this.$route.params.lang as "pt" | "en");
    }
  }

  mounted() {
    for (const key in this.$store.state.sounds) {
      this.$store.state.sounds[key as SoundString].stop();
    }
  }
}
